import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Topbar from "./Topbar";
import Footer from "./Footer";

const API_URL = process.env.REACT_APP_API_URL;

export default function ViewAllArticles() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/articles`);
        const data = await res.json();
        setArticles(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Error fetching articles:", err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="listing-page">
      <Topbar />

      <header className="listing-header">
        <div className="shell">
          <p className="eyebrow">Research Articles</p>
          <h1 className="section-title">
            All <em>research articles</em>.
          </h1>
        </div>
      </header>

      <main className="listing-body">
        <div className="shell">
          {loading ? (
            <div className="loader-wrap">
              <div className="loader" />
            </div>
          ) : articles.length === 0 ? (
            <p className="empty-state">No articles published yet.</p>
          ) : (
            <div className="card-grid">
              {articles.map((a) => (
                <Link
                  key={a._id}
                  to={`/articles/${encodeURIComponent(a.name)}`}
                  className="card"
                >
                  <div className="card-thumb">
                    {a.thumbnail && <img src={a.thumbnail} alt={a.name} />}
                  </div>
                  <div className="card-body">
                    <p className="card-meta">
                      {new Date(a.date).toLocaleDateString("en-US", {
                        month: "long",
                        day: "numeric",
                        year: "numeric",
                      })}
                    </p>
                    <h3 className="card-title">{a.name}</h3>
                    <p className="card-excerpt">{a.description}</p>
                    <p className="card-cta">Read Article</p>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
}
